<template>
  <section id="aok-explanation">
    <div class="mb-5 px-3">
      <h2 class="is-size-2 is-size-3-mobile">{{ $t("aokPlus.itsThatSimple") }} <br /></h2>

      <div class="column is-four-fifths-desktop">
        <p class="explanation mt-5">
          <slot name="explanation-slot"></slot>
          <span v-if="isAokRpsVersion"> </span>
          <span v-else-if="isMobilHealthInsuranceVersion">
            {{ $t("aokPlus.mobilFull") }}
          </span>
        </p>
        <div v-if="isAokRpsVersion" class="demonstrate-two-versions">
          <ul class="mb-3 mt-5 bold-text">
            <li>{{ isAokRpsVersion ? $t("aokRps.firstOption") : $t("aokPlus.firstOption") }}</li>
          </ul>
          <p>{{ $t("aokPlus.or") }}</p>
          <ul class="mt-1 bold-text">
            <li>{{ isAokRpsVersion ? $t("aokRps.secondOption") : $t("aokPlus.secondOption") }}</li>
          </ul>
        </div>
      </div>
      <HealthInsuranceExplanationCardContainer :health-insurance="healthInsurance" />
    </div>
  </section>
</template>

<script>
import HealthInsurances from "~/models/healthInsurances.js"
import HealthInsuranceExplanationCardContainer from "~/components/healthInsurance/HealthInsuranceExplanationCardContainer.vue"

export default {
  name: "HealthInsuranceExplanation",
  components: { HealthInsuranceExplanationCardContainer },
  props: {
    healthInsurance: {
      type: String,
      default: HealthInsurances.aokPlus,
    },
  },
  computed: {
    isAokRpsVersion() {
      return this.healthInsurance === HealthInsurances.aokRps
    },
    isMobilHealthInsuranceVersion() {
      return this.healthInsurance === HealthInsurances.mobil
    },
    isOneOfAokVersions() {
      return this.healthInsurance === HealthInsurances.aokRps || this.healthInsurance === HealthInsurances.aokPlus
    },
  },
}
</script>

<style scoped lang="scss">
ul {
  list-style-type: disc;
  padding-left: 0;
  margin-left: 2rem;
}
.bold-text {
  font-weight: 600;
}
</style>
